module.exports = __webpack_public_path__ + "img/close-button-white.25ec01c2.svg";